module.exports = __webpack_public_path__ + "img/grid-columns.91d6b560.png";